import BannerFeaturesList from "./components/BannerFeaturesList";

import Data from "../../data/banner_featureAI.json";
import BannerWatchVideo from "./components/BannerWatchVideo";

function BannerTextAI() {
  return (
    <div className="banner-ai-text mb-4">
      <h1>Data Science Course in Bangalore</h1>
      <div class="m-auto">
      <p style={{ color: "white", fontSize: "16px", textAlign:"LEFT" }}>Interactive Classes in Bangalore With Data Science Projects</p>
      </div>
      
      <div className="hero-event-lable py-2 px-3 my-4 bg-light rounded d-flex justify-content-between align-items-center">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="w-6 h-6"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5m-9-6h.008v.008H12v-.008ZM12 15h.008v.008H12V15Zm0 2.25h.008v.008H12v-.008ZM9.75 15h.008v.008H9.75V15Zm0 2.25h.008v.008H9.75v-.008ZM7.5 15h.008v.008H7.5V15Zm0 2.25h.008v.008H7.5v-.008Zm6.75-4.5h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V15Zm0 2.25h.008v.008h-.008v-.008Zm2.25-4.5h.008v.008H16.5v-.008Zm0 2.25h.008v.008H16.5V15Z"
          />
        </svg>
        <p className="p-0 m-0 text-dark">Next Batch Starting On 13th Sept</p>
      </div>
      <BannerWatchVideo ytUrl="https://www.youtube.com/embed/MZ6eHbNnngk?si=g4l-vDg4E0vXAMBG" />
      {Data.map((data) => (
        <BannerFeaturesList key={data.id} lable={data.lable} />
      ))}
      {/* <p>
        Gain expertise in Data Science from leading professionals worldwide and
        obtain a Data Science Certification from prestigious organisations.
        Develop into a skilled Data Scientist by enrolling in our comprehensive
        Data Science courses tailored for working professionals.
      </p> */}
    </div>
  );
}
export default BannerTextAI;
